import { render, staticRenderFns } from "./plant-item-modal.vue?vue&type=template&id=63db2824"
import script from "./plant-item-modal.ts?vue&type=script&lang=ts&external"
export * from "./plant-item-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./plant-item-modal.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63db2824')) {
      api.createRecord('63db2824', component.options)
    } else {
      api.reload('63db2824', component.options)
    }
    module.hot.accept("./plant-item-modal.vue?vue&type=template&id=63db2824", function () {
      api.rerender('63db2824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/plant-item-modal/plant-item-modal.vue"
export default component.exports